import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
import { Vex } from './vex';
import { Stave } from './stave';
export var TabStave = /*#__PURE__*/function (_Stave) {
  _inherits(TabStave, _Stave);

  function TabStave(x, y, width, options) {
    var _this;

    _classCallCheck(this, TabStave);

    var tab_options = {
      spacing_between_lines_px: 13,
      num_lines: 6,
      top_text_position: 1
    };
    Vex.Merge(tab_options, options);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabStave).call(this, x, y, width, tab_options));

    _this.setAttribute('type', 'TabStave');

    return _this;
  }

  _createClass(TabStave, [{
    key: "getYForGlyphs",
    value: function getYForGlyphs() {
      return this.getYForLine(2.5);
    } // Deprecated

  }, {
    key: "addTabGlyph",
    value: function addTabGlyph() {
      this.addClef('tab');
      return this;
    }
  }]);

  return TabStave;
}(Stave);